<template>
  <v-card v-if="options">
    <v-card-title>
      {{ $t("auditor.bookingDeadlineForm.title") }}
    </v-card-title>

    <v-card-subtitle>
      {{ $t("auditor.bookingDeadlineForm.subtitle") }}
    </v-card-subtitle>

    <v-card-text>
      <v-form ref="form" v-model="valid">
        <v-row>
          <v-col cols="6">
            <v-dialog
              ref="yellowDateDialog"
              v-model="yellowDateModal"
              :return-value.sync="yellowDate"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="yellowDate"
                  :label="$t('auditor.applicationDeadlineForm.date.label')"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  required
                ></v-text-field>
              </template>
              <v-date-picker v-model="yellowDate" scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="yellowDateModal = false">{{ $t("action.cancel") }}</v-btn>
                <v-btn text color="primary" @click="$refs.yellowDateDialog.save(yellowDate)">{{
                  $t("action.ok")
                }}</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>

          <v-col cols="6">
            <v-dialog
              ref="yellowTimeDialog"
              v-model="yellowTimeModal"
              :return-value.sync="yellowTime"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="yellowTime"
                  :label="$t('auditor.applicationDeadlineForm.time.label')"
                  prepend-icon="mdi-clock-time-four-outline"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  required
                ></v-text-field>
              </template>
              <v-time-picker v-if="yellowTimeModal" v-model="yellowTime" format="24hr" full-width>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="yellowTimeModal = false">{{ $t("action.cancel") }}</v-btn>
                <v-btn text color="primary" @click="$refs.yellowTimeDialog.save(yellowTime)">{{
                  $t("action.ok")
                }}</v-btn>
              </v-time-picker>
            </v-dialog>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-dialog
              ref="orangeDateDialog"
              v-model="orangeDateModal"
              :return-value.sync="orangeDate"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="orangeDate"
                  :label="$t('auditor.applicationDeadlineForm.date.label')"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  required
                ></v-text-field>
              </template>
              <v-date-picker v-model="orangeDate" scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="orangeDateModal = false">{{ $t("action.cancel") }}</v-btn>
                <v-btn text color="primary" @click="$refs.orangeDateDialog.save(orangeDate)">{{
                  $t("action.ok")
                }}</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>

          <v-col cols="6">
            <v-dialog
              ref="orangeTimeDialog"
              v-model="orangeTimeModal"
              :return-value.sync="orangeTime"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="orangeTime"
                  :label="$t('auditor.applicationDeadlineForm.time.label')"
                  prepend-icon="mdi-clock-time-four-outline"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  required
                ></v-text-field>
              </template>
              <v-time-picker v-if="orangeTimeModal" v-model="orangeTime" format="24hr" full-width>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="orangeTimeModal = false">{{ $t("action.cancel") }}</v-btn>
                <v-btn text color="primary" @click="$refs.orangeTimeDialog.save(orangeTime)">{{
                  $t("action.ok")
                }}</v-btn>
              </v-time-picker>
            </v-dialog>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-dialog ref="redDateDialog" v-model="redDateModal" :return-value.sync="redDate" persistent width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="redDate"
                  :label="$t('auditor.applicationDeadlineForm.date.label')"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  required
                ></v-text-field>
              </template>
              <v-date-picker v-model="redDate" scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="redDateModal = false">{{ $t("action.cancel") }}</v-btn>
                <v-btn text color="primary" @click="$refs.redDateDialog.save(redDate)">{{ $t("action.ok") }}</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>

          <v-col cols="6">
            <v-dialog ref="redTimeDialog" v-model="redTimeModal" :return-value.sync="redTime" persistent width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="redTime"
                  :label="$t('auditor.applicationDeadlineForm.time.label')"
                  prepend-icon="mdi-clock-time-four-outline"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  required
                ></v-text-field>
              </template>
              <v-time-picker v-if="redTimeModal" v-model="redTime" format="24hr" full-width>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="redTimeModal = false">{{ $t("action.cancel") }}</v-btn>
                <v-btn text color="primary" @click="$refs.redTimeDialog.save(redTime)">{{ $t("action.ok") }}</v-btn>
              </v-time-picker>
            </v-dialog>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-btn @click="update" :loading="loading" color="secondary">
        {{ $t("auditor.applicationDeadlineForm.update") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import UpdateOptionMutation from "@/gql/mutations/UpdateOptionMutation.gql";
import OptionsQuery from "@/gql/queries/auditor/OptionsQuery.gql";

export default {
  data() {
    return {
      valid: false,
      loading: false,
      yellowDateModal: false,
      yellowTimeModal: false,
      orangeDateModal: false,
      orangeTimeModal: false,
      redDateModal: false,
      redTimeModal: false,
      options: null,
      yellowDate: null,
      yellowTime: null,
      orangeDate: null,
      orangeTime: null,
      redDate: null,
      redTime: null,
    };
  },

  apollo: {
    options: {
      query: OptionsQuery,
      fetchPolicy: "network-only",
      update(data) {
        if (data.options) {
          this.yellowDate = data.options.find((option) => option.key === "yellowDeadline")?.value.substr(0, 10);
          this.yellowTime = data.options.find((option) => option.key === "yellowDeadline")?.value.substr(11, 5);
          this.orangeDate = data.options.find((option) => option.key === "orangeDeadline")?.value.substr(0, 10);
          this.orangeTime = data.options.find((option) => option.key === "orangeDeadline")?.value.substr(11, 5);
          this.redDate = data.options.find((option) => option.key === "redDeadline")?.value.substr(0, 10);
          this.redTime = data.options.find((option) => option.key === "redDeadline")?.value.substr(11, 5);
        }

        return data.options;
      },
    },
  },

  computed: {
    yellowDeadline() {
      return `${this.yellowDate}T${this.yellowTime}:00.000Z`;
    },

    orangeDeadline() {
      return `${this.orangeDate}T${this.orangeTime}:00.000Z`;
    },

    redDeadline() {
      return `${this.redDate}T${this.redTime}:00.000Z`;
    },
  },

  methods: {
    async update() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;

      this.$apollo.mutate({
        mutation: UpdateOptionMutation,
        variables: {
          key: "yellowDeadline",
          value: this.yellowDeadline,
        },
      });

      this.$apollo.mutate({
        mutation: UpdateOptionMutation,
        variables: {
          key: "orangeDeadline",
          value: this.orangeDeadline,
        },
      });

      this.$apollo.mutate({
        mutation: UpdateOptionMutation,
        variables: {
          key: "redDeadline",
          value: this.redDeadline,
        },
      });

      this.loading = false;
    },
  },
};
</script>
